// Which currently-active class a student is grouped under — used everywhere a
// student must appear under exactly ONE class: the Emergency board + recap, the
// school-wide absent board, and the admin School Roster. The precedence lives in
// ONE place so those surfaces never disagree about where a kid shows up (they had
// drifted before: the live board honored the homeroom flag, the recap/absent-board/
// roster did not, so the same student could group under a different class on each).
//
// Precedence:
//   1. an explicit per-student `homeroomClassId` (if that class is still active)
//   2. a class the owner flagged as their homeroom (`isHomeroom`) that the kid is in
//   3. their first active enrolled class that is NOT a specials/pull-out class
//   4. their first active enrolled class (only specials left → use it; a solo
//      specialist's kids with no homeroom still get accounted for)
//   5. none → the caller excludes them / buckets them as Unassigned
//
// `activeClassIds` and `homeroomClassIds` are Sets of class ids the caller has
// already scoped to non-archived classes. `homeroomClassIds` and `specialsClassIds`
// are optional; omit them (or pass null) to skip tiers 2 / the specials preference.
// The specials rule (3 before 4) keeps a kid grouped under their real homeroom
// rather than a pull-out class they happen to be enrolled in first — but never
// hides a kid with ONLY a specials class.
export function activeClassOf(student, activeClassIds, homeroomClassIds, specialsClassIds) {
  const home = student.homeroomClassId;
  if (home && activeClassIds.has(home)) return home;
  const enrolled = student.enrolledClasses || [];
  if (homeroomClassIds) {
    const flagged = enrolled.find((cid) => homeroomClassIds.has(cid));
    if (flagged) return flagged;
  }
  const activeEnrolled = enrolled.filter((cid) => activeClassIds.has(cid));
  if (specialsClassIds) {
    const nonSpecials = activeEnrolled.find((cid) => !specialsClassIds.has(cid));
    if (nonSpecials) return nonSpecials;
  }
  return activeEnrolled[0] || null;
}
